export class TaskDetails {
    constructor(
         public createdBy ?:  string ,
         public createdDt ?:  string ,
         public recordVersion ?: number,
         public id ?: number,
         public empPlanStartDt ?:  string ,
         public estimatedCompletionDt ?:  string ,
         public clientAgreementDt ?:  string ,
         public shortTermGoalCd ?:  string ,
         public longTermGoalCd ?:  string ,
         public empPlanStatusCd ?:  string ,
         public empPlanStatusDt ?:  string ,
         public notes ?:  string ,
         public deleteSw ?:  string ,
         public etEnrollmentId ?: number,
         public lastModifiedDate ?:  string ,
         public createdDate ?:  string, ) {
         }
}


// WEBPACK FOOTER //
// ./src/app/shared/model/task-details.model.ts